<template>
  <div class="event-canceled-report-form py-1">
    <v-row>
      <v-col cols="12">
        <v-textarea
          v-model="form.notes"
          name="notes"
          :rows="6"
          :label="`${$t('PLANNINGS.NOTES')} *`"
          :readonly="readonly"
          :rules="getRulesByName('notes')"
          :error-messages="errors.notes"
          outlined
          @input="updateValue('notes', $event)"
        ></v-textarea>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import { notEmpty } from '@/modules/_global/variables/rules';

export default {
  name: 'EventCancelledReportForm',

  mixins: [formEditable],

  data() {
    return {
      form: {
        notes: ''
      },
      rules: {
        notes: [notEmpty]
      }
    };
  }
};
</script>

<style lang="scss">
.event-canceled-report-form {
  .row {
    margin-top: -4px;
    margin-bottom: -4px;

    & + .row {
      margin-top: 4px;
    }

    > .col,
    > [class*='col-'] {
      padding-top: 4px;
      padding-bottom: 4px;
    }

    &.no-gutters > .col,
    &.no-gutters > [class*='col-'] {
      padding: 0;
    }
  }
}
</style>
